import * as React from "react";
import { useEffect } from "react";
import { Link } from "gatsby";
import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from '@mui/icons-material/X';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

export default function Footer() {


  return (
    <Container
      className="hero"
      maxWidth="false"
      align="center"
      sx={{
        bgcolor: "primary.main",
        py: 8,
      }}
    >

      <Container
            maxWidth="lg"
            align="center"
            sx={{
              mb: 8,
            }}
      >
        
        <Grid container spacing={2}>
          <Grid 
            size={{ xs: 12, sm: 9 }}
            textAlign={{ xs: 'center', sm: 'left', }}
          >
            
          <Box
                component="form"
                sx={{ display: 'flex', gap: 2, alignItems: 'center' }}
              >


                <Typography
          component="FooterSmall"
          variant="FooterSmall"
          color="primary.contrastText"
        >
          <Link
            to="/terms-of-service"
            activeClassName="activeNavLink"
            className="footerLink"
          >
            Terms of Service
          </Link>
          &nbsp;|&nbsp;
          <Link
            to="/terms-of-use"
            activeClassName="activeNavLink"
            className="footerLink"
          >
            Terms of Use
          </Link>
          &nbsp;|&nbsp;
          <Link
            to="/privacy-policy"
            activeClassName="activeNavLink"
            className="footerLink"
          >
            Privacy Policy
          </Link>
          &nbsp;|&nbsp;
          <Link
            to="/privacy-framework"
            activeClassName="activeNavLink"
            className="footerLink"
          >
            3Aware™ EU-U.S. Data Privacy Framework (EU-U.S. DPF) Notice
          </Link>
        </Typography>
                
                {/*<TextField
                  placeholder="Email address"
                  type="email"
                  variant="outlined"
                  size="small"
                  required
                  sx={{ backgroundColor: 'white', borderRadius: 1 }}
                />
                <Button
                  variant="contained"
                  color="secondary"
                  type="submit"
                  endIcon={<EastIcon />}
                >
                  Subscribe
                </Button>*/}
              </Box>

          </Grid>
          <Grid 
            size={{ xs: 12, sm: 3 }} 
            textAlign={{ xs: 'center', md: 'right', }}
          >
          <Link
                href="https://www.linkedin.com/company/3aware"
                className="footerMenuLink"
                target="_blank"
              >
                <LinkedInIcon aria-hidden="true" focusable="false" sx={{ verticalAlign: 'middle', fontSize: '32px' }} />
              </Link>

              <Link
                href="https://x.com/3AwareAI"
                className="footerMenuLink"
                target="_blank"
              >
                <XIcon aria-hidden="true" focusable="false" sx={{ verticalAlign: 'middle', fontSize: '30px' }} />
              </Link>
          </Grid>
        </Grid>



        
        <Grid container alignItems="flex-start" columns={12} direction={"row"} spacing={2}
          sx={{
            
          }}
        >
          <Grid item xs={12} md={9} direction={"column"}>
            {/* Left column content */}
            

          </Grid>
          <Grid item xs={12} md={3} sx={{ textAlign: 'right' }} direction={"column"}>


          </Grid>
        </Grid>
      </Container>

    </Container>
  );
}
